import { ChangeBusinessDetails } from './ChangeBusinessDetails';

export class ChangeTermsAndConditions extends ChangeBusinessDetails {
  type: string = 'ChangeTermsAndConditions';
}
